<!--
  A modal, unlike the capture widget it is launched from. The reported screen
  deliberately stops being reachable here: this step exists to make the
  reporter look at the image itself, and a surface they can click past is a
  step they can skip past.
-->
<div class="redactor-backdrop">
  <div class="redactor-panel" role="dialog" aria-modal="true">
    <header class="redactor-header">
      <h2 class="redactor-title">
        <i class="ti ti-eraser"></i>
        {{ 'Support_TicketCapture:redactorTitle' | translate }}
      </h2>
      <span class="redactor-count" data-testid="redaction-count">
        {{ 'Support_TicketCapture:redactedAreas' | translate }}: {{ redactionCount() }}
      </span>
    </header>

    <p class="redactor-instruction">
      <i class="ti ti-info-circle"></i>
      {{ 'Support_TicketCapture:redactorInstruction' | translate }}
    </p>

    <div class="redactor-stage">
      @if (loading()) {
        <div class="redactor-status">
          {{ 'Support_TicketCapture:redactorLoading' | translate }}
        </div>
      }
      @if (failed()) {
        <div class="redactor-status redactor-status-error" data-testid="redactor-error">
          {{ 'Support_TicketCapture:redactorFailed' | translate }}
        </div>
      }
      <!--
        Kept in the DOM while loading: Fabric binds to this element, so it has
        to exist before the image resolves.
      -->
      <canvas #canvasEl class="redactor-canvas"></canvas>
    </div>

    <div class="redactor-tools">
      <button
        type="button"
        class="btn btn-xs btn-secondary"
        [disabled]="redactionCount() === 0 || exporting()"
        (click)="undo()"
      >
        <i class="ti ti-arrow-back-up"></i>
        {{ 'Support_TicketCapture:undoArea' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-xs btn-secondary"
        [disabled]="redactionCount() === 0 || exporting()"
        (click)="clear()"
      >
        <i class="ti ti-trash"></i>
        {{ 'Support_TicketCapture:clearAreas' | translate }}
      </button>
    </div>

    <footer class="redactor-footer">
      <label class="redactor-acknowledge">
        <input
          type="checkbox"
          data-testid="redaction-acknowledge"
          [checked]="acknowledged()"
          [disabled]="loading() || exporting()"
          (change)="acknowledged.set($any($event.target).checked)"
        />
        <span>{{ 'Support_TicketCapture:redactorAcknowledge' | translate }}</span>
      </label>

      <div class="redactor-actions">
        <button
          type="button"
          class="btn btn-xs btn-secondary"
          [disabled]="exporting()"
          (click)="onCancel()"
        >
          {{ 'Support_TicketCapture:cancel' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-xs btn-primary"
          data-testid="redaction-apply"
          [disabled]="!canApply()"
          (click)="apply()"
        >
          <i class="ti ti-check"></i>
          {{ 'Support_TicketCapture:applyAndAttach' | translate }}
        </button>
      </div>
    </footer>
  </div>
</div>
